import contact from '../shared/contact';

const partner = `
    contact {
        ${contact}
    }
    icon
    id
    paymentDeadline
    prices {
        A
        B
        C
        D
        E
        F
    }
    services
`;

export default partner;
